import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "fontsource-roboto";
import App from "./components/App";
import * as serviceWorker from "./serviceWorker";
import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import { Provider } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import { BrowserRouter, Route } from "react-router-dom";
import rootReducer from "./reducers";
import ReduxThunk from "redux-thunk";

if (process.env.NODE_ENV !== "development") {
  console.log = () => {};
}

const store = createStore(rootReducer, applyMiddleware(ReduxThunk));

var firebaseConfig = {
  apiKey: "AIzaSyD2eOE_SA66QhxsPNytOEJLbQfgSi08vU8",
  authDomain: "str-supplierportal.firebaseapp.com",
  databaseURL: "https://str-supplierportal.firebaseio.com",
  projectId: "str-supplierportal",
  storageBucket: "str-supplierportal.appspot.com",
  messagingSenderId: "372897612089",
  appId: "1:372897612089:web:f1c3cf3087a85f93"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <Route path="/" component={App} />
    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
